define('common/tuple',["require", "exports"], function (require, exports) {
    "use strict";
    var Tuple = (function () {
        function Tuple(item1, item2) {
            this.item1 = item1;
            this.item2 = item2;
        }
        return Tuple;
    }());
    return Tuple;
});

